/**
 * Schema for nonEditable, nodeType = nonEditable
 */
export const nonEditable = {
  name: "nonEditable",
  inline: true,
  group: "inline",
  content: "inline+",
  marks: "_",
  attrs: {
    contenteditable: { default: null },
    class: { default: "" }, // Allow dynamic classes
    style: { default: null },
    id: { default: null },
  },
  // atom: true,
  parseDOM: [
    {
      tag: "span.uneditable",
      priority: 51,
      getAttrs: (dom) => ({
        id: dom.getAttribute("id"),
        class: dom.getAttribute("class"), // Get the dynamic class from the DOM
      }),
    },
  ],
  // The styles can be added via the class as well
  toDOM: (node) => {
    const defaultClass = "uneditable d-inline-block cursor-pointer mb-1 mr-1";
    return [
      "span",
      {
        contenteditable: false,
        class: node.attrs.class?.includes(defaultClass) ? node.attrs.class : `${defaultClass} ${node.attrs.class}`,
        id: node.attrs.id,
      },
      0,
    ];
  },
};
